<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_explore_scout')
}

const isOnMap = computed(() => {
  return route.path.startsWith('/map')
})

const goToMap = () => {
  router.push('/map')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/exploration.webm"
  >
    <template #text>
      <p class="pb-2">{{ t('tutorial.exploration.scout.great') }}</p>
      <p class="pb-2">
        {{ t('tutorial.exploration.scout.launchScout') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info">
        <div class="ml-3">
          <ul class="list-decimal">
            <li>{{ t('tutorial.exploration.scout.findHomeworld') }}</li>
            <li>{{ t('tutorial.exploration.scout.clickName') }}</li>
            <li>{{ t('tutorial.exploration.scout.findScout') }}</li>
            <li><i18n-t keypath="tutorial.exploration.scout.selectMove" tag="span"><template #icon><GenericIcon type="cmd_move"/></template></i18n-t></li>
            <li>{{ t('tutorial.exploration.scout.findStar') }}</li>
            <li>{{ t('tutorial.exploration.scout.selectSet') }}</li>
          </ul>
        </div>
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnMap" @click="goToMap" class="mr-2">{{ t('common.actions.gotoMap') }}</ActionButton>
      <ActionButton @click="handleNextStep">{{ t('common.actions.doneWhatsNext') }}</ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>